import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { AccountActionsService } from '@personal-area/global/accounts/ui';

import { DemoFundsButtonComponent } from './demo-funds-button.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [DemoFundsButtonComponent],
  exports: [DemoFundsButtonComponent],
  providers: [AccountActionsService]
})
export class DemoFundsButtonModule { }
